var exports = {
  "f": "createBranchLink__2g24Nr",
};

module.exports = exports;
